// Totals for the purchase orders shown in the list: count, garments (pcs), fabric (metres) and value per currency.
// Different currencies are never added together. No browser needed, so it can be tested directly.
import { formatMoney } from "./fieldformat.js";

export interface PoTotalsRow { totalQty?: number; fabricQty?: number; totalAmount?: number; currency?: string }
export interface PoTotals {
  count: number;
  /** Garment pieces, or null when the person can't see quantities. */
  pcs: number | null;
  metres: number | null;
  /** [currency, total], the currency with most orders first, or null when the person can't see amounts. */
  values: Array<[string, number]> | null;
}

export function poTotals(rows: PoTotalsRow[]): PoTotals {
  const qty = rows.some((r) => r.totalQty !== undefined);
  const amounts = rows.some((r) => r.totalAmount !== undefined);
  const cents = new Map<string, number>(), orders = new Map<string, number>();
  for (const r of rows) {
    if (r.totalAmount === undefined) continue;
    const cur = r.currency || "";
    cents.set(cur, (cents.get(cur) || 0) + Math.round(Number(r.totalAmount || 0) * 100));
    orders.set(cur, (orders.get(cur) || 0) + 1);
  }
  return {
    count: rows.length,
    pcs: qty ? rows.reduce((n, r) => n + Number(r.totalQty || 0), 0) : null,
    metres: qty ? Math.round(rows.reduce((n, r) => n + Number(r.fabricQty || 0), 0) * 1000) / 1000 : null,
    values: amounts ? [...cents].sort(([a], [b]) => orders.get(b)! - orders.get(a)! || a.localeCompare(b)).map(([c, v]) => [c, v / 100] as [string, number]) : null,
  };
}

const whole = (n: number) => n.toLocaleString("en-GB", { maximumFractionDigits: 2 });
export const pcsText = (n: number) => `${whole(n)} pcs`;
export const metresText = (n: number) => `${whole(n)} m fabric`;
/** "USD 114,088.00" for each currency. */
export const valueTexts = (values: Array<[string, number]>) => values.map(([c, v]) => `${c ? `${c} ` : ""}${formatMoney(v, 2)}`);
